import { matchRoutes } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";
import { ROUTE_FEATURES, type RouteKey } from "@/routes/routeFeatures";

// Config keys whose mounted pages add parameters below the configured base path.
const nestedPaths: Partial<Record<RouteKey, string[]>> = {
	HELP_CENTER_ADMIN: ["/:conversationId"],
	LEAD_SCORING: ["/changelog"],
	LISTS_DETAIL: ["/:id"],
	MESSAGE_CENTER: ["/:id"],
	COMPANIES: ["/:id"],
	NEW_LIST: [
		"/details/:id",
		"/filter/:id",
		"/source/:id",
		"/settings/:id",
		"/copywriting/:id",
		"/signals/:id",
	],
	PROFILE_TRACKER: ["/create", "/edit/:id", "/settings/:id", "/detail/:id"],
	SUPPORT: ["/:id"],
	TICKETS: ["/:id"],
};
const routes = (Object.entries(ROUTE_CONFIG) as [RouteKey, string][])
	.filter(([, path]) => !path.includes("?"))
	.flatMap(([key, path]) => [
		{ path, key },
		...(nestedPaths[key] ?? []).map((suffix) => ({ path: path + suffix, key })),
	]);

// USERS config points at a company tab; Admin also mounts the standalone users page.
routes.push({ path: "/app/users", key: "USERS" });

/** Resolve to catalog keys only. Parameters and search strings never leave the browser. */
export function resolveProductRoute(pathname: string) {
	const match = matchRoutes(routes, { pathname })?.[0];

	if (!match) {
		return null;
	}

	const key = match.route.key;

	return { key, feature: ROUTE_FEATURES[key] };
}
